<template>
  <el-dialog title="审批" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">
    <div class="dlg-content">
      <el-form class="global-form" v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
               :rules="rules" ref="form2" label-width="130px">
        <el-row>
          <el-col :span="24" key="1" v-if="urlType === '10'">
            <el-form-item prop="skNumber" label="补贴金额">
              <el-input placeholder="请输入补贴金额" v-model="formData.skNumber">
              </el-input>
            </el-form-item>
          </el-col>

          <!-- 新增：合同编号 -->
          <el-col :span="24" v-if="urlType === '2' && !isChildOrder">
            <el-form-item prop="contractNo" label="合同编号">
              <el-input placeholder="请输入合同编号" v-model="formData.contractNo"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="urlType !== '10'">
            <el-form-item prop="approvalStatus" label="审批状态">
              <el-radio-group v-model="formData.approvalStatus">
                <el-radio label="2">审核通过</el-radio>
                <el-radio label="3">审核驳回</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <template v-if="urlType !== '10'">
            <el-col :span="24" key="1" v-if="formData.approvalStatus === '3'">
              <el-form-item prop="approvalComments" label="审批意见">
                <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
                          v-model="formData.approvalComments">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" key="2" v-else>
              <el-form-item label="审批意见">
                <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
                          v-model="formData.approvalComments">
                </el-input>
              </el-form-item>
            </el-col>
          </template>

          <el-col :span="24" key="4" v-if="urlType != '5' && urlType != '7' && urlType != '10'">
            <el-form-item label="附件" prop="fileList" v-if="vehicle && formData.approvalStatus === '2'">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>

            <el-form-item label="附件" v-else>
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    relatedId: {
      type: String,
      default: ''
    },
    showDlg: {
      type: Boolean,
      default: false
    },
    urlType: {
      type: String,
      default: ''
    },
    isChildOrder: {
      type: Boolean,
      default: false
    },
    vehicle: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      statusList2: [
        {
          label: '审批通过',
          value: '2'
        },
        {
          label: '审批驳回',
          value: '3'
        }
      ],
      formData: {
        relatedId: '',
        approvalStatus: '',
        approvalComments: '',
        fileList: [],
        contractNo: '', // 新增合同编号
        skNumber: ''
      },
      rules: {
        approvalStatus: [
          {
            required: true,
            message: '请选择审批状态',
            trigger: ['blur', 'change']
          }
        ],
        skNumber: [
          {
            required: true,
            message: '请输入补贴金额',
            trigger: ['blur', 'change']
          }
        ],
        contractNo: [ // 新增合同编号校验
          {
            required: true,
            message: '请输入合同编号',
            trigger: ['blur', 'change']
          }
        ],
        isVehicle: [
          {
            required: true,
            message: '请选择车辆预约',
            trigger: ['blur', 'change']
          }
        ],
        vehicleDateStart: [
          {
            required: true,
            message: '请选择开始时间',
            trigger: ['blur', 'change']
          }
        ],
        approvalComments: [
          {
            required: true,
            message: '请输入审批意见',
            trigger: ['blur', 'change']
          }
        ],
        fileList: [
          {
            required: true,
            message: '请上传附件',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  computed: {},
  created() {
    console.log('this.vihicle', this.vehicle)
    if (this.vehicle) {
      // this.$set(this.formData, 'isVehicle', '')
      // this.$set(this.formData, 'vehicleDateStart', '')
      // this.$set(this.formData, 'vehicleDateEnd', '')
    }
    if (this.urlType === '10') {
      this.$set(this.formData, 'skNumber', '')
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeDlg')
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        if (this.vehicle && this.formData.approvalStatus === '2' && this.formData.fileList?.length === 0) {
          this.$message.error('请上传附件')
          return
        }
        console.log(this.formData)
        this.loading = true
        this.formData.relatedId = this.relatedId

        let params = {}
        if (this.urlType === '5') {
          delete this.formData.fileList
          params = {
            recordId: this.relatedId,
            approveResult: this.formData.approvalStatus,
            approveComment: this.formData.approvalComments,
            contractNo: this.formData.contractNo // 5类型带上合同编号
          }
        } else {
          params = this.formData
        }
        if (this.urlType === '7') {
          delete params.fileList
        }
        // 填写回购补贴金额不需要填写这些字段
        if (this.urlType === '10') {
          delete params.approvalStatus
          delete params.approvalComments
          delete params.fileList
          delete params.contractNo // 补贴页面删除合同编号字段
        }
        console.log('params: ', params)

        const obj = {
          1: this.$apis.bondRecord.approvaYxUserDepositRecord, // 保证金充值退还审核
          2: this.$apis.orderManage.approvalYxPriceOrder, // 锁价订单审核
          3: this.$apis.deliveryOrder.approvalYxPickupOrder, // 提货订单
          4: this.$apis.bondRecord.approvaYxUserGoodsRecord, // 发货订单
          5: this.$apis.vehicleAccess.updatePaVehicleOut, // 车辆出入厂
          6: this.$apis.orderManage.approvalYxPriceOrderRes, // 车辆出入厂
          7: this.$apis.sealApply.approvalSealApply, // 用印申请审批
          8: this.$apis.orderManage.approvalYxPriceOrderHg, // 回购业务员审核
          9: this.$apis.orderManage.approvalYxPriceOrderHg, // 回购业务经理审核
          10: this.$apis.orderManage.approvalYxPriceOrderHg // 填写补贴金额
        }
        this.$axios.post(obj[this.urlType], params).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
